/**
 * FormFlu Features Section
 * 
 * Showcases the key features and benefits of FormFlu.
 * Organized in a grid with icons and descriptions.
 */

import './Features.css';

const features = [
  {
    icon: '🔒',
    title: 'HIPAA-First Security',
    description: 'Built from the ground up for healthcare. PHI encryption, audit trails, BAA included. Your patient data stays protected.',
    badge: 'Compliant',
    badgeType: 'success' as const,
  },
  {
    icon: '🧪',
    title: 'A/B Testing Built-In',
    description: 'Test different form versions, question orders, and layouts. Find what converts best without the guesswork.',
    badge: 'Optimize',
    badgeType: 'teal' as const,
  },
  {
    icon: '📊',
    title: 'Funnel Analytics',
    description: 'See exactly where patients drop off. Step-by-step completion rates help you identify and fix friction points.',
    badge: 'Insights',
    badgeType: 'teal' as const,
  },
  {
    icon: '📱',
    title: 'Multi-Step Forms',
    description: 'Break long forms into digestible steps. Progress indicators and auto-save keep patients engaged.',
    badge: 'UX',
    badgeType: 'teal' as const,
  },
  {
    icon: '⚡',
    title: 'Embeddable Anywhere',
    description: 'Drop a single script tag on any website. Works with your existing CMS, EHR portal, or patient engagement platform.',
    badge: 'Easy',
    badgeType: 'teal' as const,
  },
  {
    icon: '🏢',
    title: 'Multi-Tenant Ready',
    description: 'Perfect for agencies and health systems. Complete data isolation between organizations with centralized management.',
    badge: 'Scale',
    badgeType: 'teal' as const,
  },
];

export function Features() {
  return (
    <section id="features" className="features section">
      <div className="container">
        {/* Section Header */}
        <div className="section-header">
          <h2 className="section-title">
            Everything You Need to <span className="text-teal">Cure</span> Your Forms
          </h2>
          <p className="section-subtitle">
            FormFlu combines compliance, optimization, and analytics in one platform 
            purpose-built for healthcare organizations.
          </p>
        </div>

        {/* Features Grid */}
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card card">
              <div className="feature-icon">{feature.icon}</div>
              <div className="feature-content">
                <div className="feature-header">
                  <h3 className="feature-title">{feature.title}</h3>
                  <span className={`badge badge-${feature.badgeType}`}>
                    {feature.badge}
                  </span>
                </div>
                <p className="feature-description">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="features-cta">
          <p className="features-cta-text">
            Ready to see how FormFlu can improve your form performance?
          </p>
          <div className="features-cta-actions">
            <a href="#" className="btn btn-primary">
              Start Free Trial
            </a>
            <a href="#" className="btn btn-ghost">
              View Documentation →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
